<template>
  <div :class="[
         type === 'textarea' ? 'el-textarea el-textarea-pro' : 'el-input el-input-pro',
         inputSize ? 'el-input--' + inputSize : '',
         {
           'is-disabled': inputDisabled,
           'is-exceed': inputExceed,
           'el-input-group': $slots.prepend || $slots.append,
           'el-input-group--append': $slots.append,
           'el-input-group--prepend': $slots.prepend,
           'el-input--prefix': $slots.prefix || prefixIcon,
           'el-input--suffix': $slots.suffix || suffixIcon || clearable || showPassword
         }
       ]"
       @mouseenter="hovering = true"
       @mouseleave="hovering = false"
  >
    <!-- 前置元素 -->
    <div class="el-input-group__prepend" v-if="$slots.prepend">
      <slot name="prepend"></slot>
    </div>
    <div
      v-if="readonly"
      ref="input"
      class="el-textarea__inner"
      v-bind="$attrs"
      tabindex="1"
      @compositionstart="handleCompositionStart"
      @compositionupdate="handleCompositionUpdate"
      @compositionend="handleCompositionEnd"
      @focus="handleFocus"
      @blur="handleBlur">
      <span v-if="!value" class="placeholder">{{ $attrs.placeholder }}</span>
      <span v-else>{{ value }}</span>
    </div>
    <template v-else>
      <input
        v-if="type !== 'textarea'"
        ref="input"
        class="el-input__inner"
        v-bind="$attrs"
        :tabindex="tabindex"
        :aria-label="label"
        :disabled="inputDisabled"
        :type="showPassword ? (passwordVisible ? 'text': 'password') : type"
        :autocomplete="autoComplete || autocomplete"
        @compositionstart="handleCompositionStart"
        @compositionupdate="handleCompositionUpdate"
        @compositionend="handleCompositionEnd"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        @change="handleChange"
      >
      <textarea
        v-else
        ref="textarea"
        class="el-textarea__inner"
        v-bind="$attrs"
        :tabindex="tabindex"
        :aria-label="label"
        :disabled="inputDisabled"
        :autocomplete="autoComplete || autocomplete"
        :style="textareaStyle"
        @compositionstart="handleCompositionStart"
        @compositionupdate="handleCompositionUpdate"
        @compositionend="handleCompositionEnd"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        @change="handleChange"
      />
    </template>
    <!-- 前置内容 -->
    <span class="el-input__prefix" v-if="$slots.prefix || prefixIcon">
      <slot name="prefix"></slot>
      <i class="el-input__icon"
         v-if="prefixIcon"
         :class="prefixIcon">
      </i>
    </span>
    <!-- 后置内容 -->
    <span
      class="el-input__suffix"
      v-if="getSuffixVisible()">
      <span class="el-input__suffix-inner">
        <template v-if="!showClear || !showPwdVisible || !isWordLimitVisible">
          <slot name="suffix"></slot>
          <i class="el-input__icon"
             v-if="suffixIcon"
             :class="suffixIcon">
          </i>
        </template>
        <i v-if="showClear"
           class="el-input__icon el-icon-circle-close el-input__clear"
           @mousedown.prevent
           @click="clear"
        ></i>
        <i v-if="showPwdVisible"
           class="el-input__icon el-icon-view el-input__clear"
           @click="handlePasswordVisible"
        ></i>
        <span v-if="isWordLimitVisible" class="el-input__count">
          <span class="el-input__count-inner">
            {{ textLength }}/{{ upperLimit }}
          </span>
        </span>
      </span>
      <i class="el-input__icon"
         v-if="validateState"
         :class="['el-input__validateIcon', validateIcon]">
      </i>
    </span>
    <!-- 后置元素 -->
    <div class="el-input-group__append" v-if="$slots.append">
      <slot name="append"></slot>
    </div>
    <span v-if="isWordLimitVisible && type === 'textarea'" class="el-input__count">{{ textLength }}/{{ upperLimit }}</span>
  </div>
</template>

<script>
export default {
  name: "ElInputPro",
  extends: window.ELEMENT.Input
}
</script>